import React from "react";
import { Box, TextField, Button } from "@mui/material";
import { NumericFormat } from "react-number-format";
import MySelect from "./MySelect";

const MyRetraitArgent = ({
  listItem = [],
  selectedItem = "",
  onSelectedItemChange = () => {},
  amount = "",
  onAmountChange = () => {},
  textValue = "",
  onTextChange = () => {},
  onSend = () => {},
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
  };

  const canSend = selectedItem && amount && textValue;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      width="100%"
      onClick={handleClick}
    >
      <MySelect
        listItem={listItem}
        value={selectedItem}
        onChange={onSelectedItemChange}
      />

      <NumericFormat
        thousandSeparator=" "
        decimalScale={2}
        decimalSeparator=","
        allowedDecimalSeparators={[",", "."]}
        customInput={TextField}
        fullWidth
        size="small"
        id="outlined-basic"
        variant="outlined"
        placeholder="0.00"
        value={amount}
        onValueChange={(values) => onAmountChange(values.value)}
      />

      <TextField
        fullWidth
        size="small"
        variant="outlined"
        placeholder="Commentaire"
        value={textValue}
        onChange={onTextChange}
      />

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          color="success"
          size="small"
          sx={{ width: 140 }}
          onClick={onSend}
          disabled={!canSend}
        >
          ENVOYER
        </Button>
      </Box>
    </Box>
  );
};

export default MyRetraitArgent;
